import { render } from "./App.vue?vue&type=template&id=63df92a5"
const script = {}

import "./App.vue?vue&type=style&index=0&id=63df92a5&lang=css"
script.render = render

export default script